import { api } from '../axiosInstance';

import { ChildProfileDTO, ChildProfileResponseDTO } from '@/entities/child/child-profile.dto';
import { ChildProfile } from '@/entities/child/child-profile.entity';
import { ChildProfileMapper } from '@/entities/child/child-profile.mapper';

export const childService = {
  getChild: async (childId: string | number): Promise<ChildProfile> => {
    const response = await api.get<ChildProfileResponseDTO>(`students/${childId}`);
    return ChildProfileMapper.toEntity(response.data.data);
  },

  createStudent: async (data: any): Promise<any> => {
    const response = await api.post('students', data);
    return response.data;
  },
};
